@use "src/styles/common/_colors.scss";

.contentWrapper {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.optionWrapper {
    gap: 10px; 
    min-width: 30px;
    padding: 0px 5px;
}

.sortTH {
    cursor: pointer !important;
    &.disabled {
        cursor: default;
    }
    position: relative;
}
.sortAsc {
    border-style: solid;
    border-width: 0 3.5px 7px;
    border-color: transparent transparent colors.$white;
    border-color: transparent transparent colors.$light-green-variant;
}

.sortDesc {
    border-style: solid;
    border-width: 7px 3.5px 0;
    border-color: colors.$white transparent transparent;
    border-color: colors.$light-green-variant transparent transparent;
}

.advancedSort:hover {
    color: colors.$label;
}
